import { render, staticRenderFns } from "./Consignaciones.vue?vue&type=template&id=39f1a437&scoped=true"
import script from "./Consignaciones.vue?vue&type=script&lang=js"
export * from "./Consignaciones.vue?vue&type=script&lang=js"
import style0 from "./Consignaciones.vue?vue&type=style&index=0&id=39f1a437&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f1a437",
  null
  
)

export default component.exports